













import Vue from 'vue'

export default Vue.extend({
  name: 'CallStatusBox',
  props: {
    voiceWaiting: {
      type: Boolean,
      required: true
    },
    videoWaiting: {
      type: Boolean,
      required: true
    },
    nozokiWaiting: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    /**
     * 通話可能
     */
    availableCall(this: any): boolean {
      return this.videoWaiting || this.voiceWaiting || this.nozokiWaiting
    }
  }
})
